module.exports = __webpack_public_path__ + "img/icn-cockft-checked.05693d5b.png";